export default __webpack_public_path__ + "static/media/applications.5a5564c5.png";